import { Divider, MenuItem, Stack, Typography, useTheme } from "@mui/material";
import { ArrowDropDown } from "@mui/icons-material";
import React, { Fragment } from "react";
import QueryPreservingLink from "../../components/QueryPreservingLink";
import { alpha } from "@mui/material/styles";

const Dropdown = ({ page, recentReportId, location }) => {
  const theme = useTheme();
  const currentUrl = location?.pathname?.replace(/\/+$/, "");

  return (
    <Stack
      sx={{
        position: "relative",
      }}
    >
      <Stack
        sx={{
          "&:hover .dropdown": {
            display: "flex",
          },
          "&:hover .icon": {
            transform: "rotate(180deg)",
          },
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontWeight: "bold",
            textDecoration: "none",
            color: page.submenu.some((item) => currentUrl?.includes(item.url))
              ? theme.palette.primary.main
              : theme.palette.secondary.main,
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
          }}
        >
          {page.name}

          <ArrowDropDown className="icon" />
        </Typography>

        <Stack
          className="dropdown"
          sx={{
            display: "none",
            position: "absolute",
            top: "24px",
            right: "0",
            backgroundColor: "#ffffff",
            borderRadius: "5px",
            boxShadow: "0 15px 30px 0 rgba(0, 0, 0, 0.15)",
            border: "solid 1px #e7e7ef",
            zIndex: 1210,
          }}
        >
          <Stack>
            {page.submenu.map((submenuItem, index) => {
              return (
                <Fragment key={index}>
                  <MenuItem
                    component={QueryPreservingLink}
                    sx={{
                      p: 2,
                      fontSize: "14px",
                      color: theme.palette.secondary.main,
                      fontWeight: "bold",
                      "&.active": {
                        color: theme.palette.primary.main,
                      },
                      "&:hover": {
                        backgroundColor: alpha(
                          theme.palette.primary.main,
                          0.15
                        ),
                      },
                      minWidth: "120px",
                      padding: "17px 31.2px 17px 18.8px",
                    }}
                    to={
                      submenuItem.name === "Pulse Report"
                        ? `${submenuItem.url}/${recentReportId}`
                        : submenuItem.url
                    }
                    activeClassName="active"
                    className={
                      (submenuItem.name === "Pulse Report" ||
                        submenuItem.name === "Reports") &&
                      location?.pathname?.includes(submenuItem.url)
                        ? "active"
                        : ""
                    }
                  >
                    {submenuItem.name}
                  </MenuItem>

                  <Divider sx={{ m: "0!important" }} />
                </Fragment>
              );
            })}
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default Dropdown;
